export default __webpack_public_path__ + "static/media/ARBITRUM.455d408c.svg";